import React, { useEffect, useState } from "react";
import DropIcon from "../../../icons/DropIcon";

const InputFile = props => {
    const { attribute, returnType, extensions, eventsHandler } = props;
    const [ dragActive, setDragActive ] = useState(false);
	const [ file, setFile ] = useState(null);

	const handleDrag = function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    }
    const handleDrop = function(e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
			selectFile(e.dataTransfer.files[0]);
        }
    }
    const onChangeFile = (e) => {
        e.preventDefault();

        if (e.target.files && e.target.files[0]) {
			selectFile(e.target.files[0]);
        }
    }
	const selectFile = file => {
		if (file !== null && file.name !== undefined)
			setFile(file);
	}
    const changeEvent = () => {
		if (file === null)
			return;

        if (eventsHandler.handleChange === undefined || eventsHandler.handleChange === null) return;
        eventsHandler.handleChange(attribute, returnType, file);
    }

	useEffect(() => {
		changeEvent();
	}, [file]);

    return (
        <div className={"formFile"} id={"form-file-upload"} onDragEnter={ handleDrag }>
            <input type={"file"} name={"file"} id="input-file-upload" onChange={ onChangeFile } />
            <label className={"inputFileDrop" + (dragActive ? " dragActive" : "")} id="label-file-upload" htmlFor="input-file-upload">
                <div>
                    <DropIcon />
                    <p className={"mainText"}>Cliquer ici ou déposer votre fichier</p>
                    <p className={"secondaryText"}>Format{ (extensions.length > 1 ? "s" : "") } accepté{ (extensions.length > 1 ? "s" : "") } : { extensions.join(", ") }</p>
                </div>
            </label>
            {
                dragActive
                && <div id="drag-file-element" onDragEnter={ handleDrag } onDragLeave={ handleDrag } onDragOver={ handleDrag } onDrop={ handleDrop } />
            }
        </div>
    );
}

export default InputFile;
